import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from '@mui/material/OutlinedInput';

const onFocusInput = (event) => {
    event.target.select();
  };
// 商品追加 商品追加フォーム
export default function AddProductForm({
  productInfoList,
  productDataInput,
  setProductDataInput,
  setProductAdded,
  disableProductName,
}) {
  const [productDataInputValue, setProductDataInputValue] = useState({
    productName: "",
    origin: "",
    displaySize: "",
    orderingUnit: "",
    added: false,
  });

  useEffect(() => {
    setProductDataInputValue(productDataInput);
  }, [productDataInput]);

  const handleChangeProductDataInput = (prop) => (event) => {
    var newProductData = {
      ...productDataInputValue,
      [prop]: event.target.value,
    };
    setProductDataInputValue(newProductData);
  };

  const handleBlurProductDataInput = (prop) => (event) => {
    var newProductData = { ...productDataInput, [prop]: event.target.value };
    setProductDataInput(newProductData);
    setProductAdded(checkProductAdded(newProductData));
  };

  const checkProductAdded = (productData) => {
    return (
      productInfoList.filter(
        (data) =>
          data.productName === productData.productName &&
          data.origin === productData.origin &&
          data.displaySize === productData.displaySize &&
          data.orderingUnit === productData.orderingUnit &&
          data.added
      ).length > 0
    );
  };

  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs="auto">
            商品名:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeProductDataInput("productName")}
              onBlur={handleBlurProductDataInput("productName")}
              value={productDataInputValue.productName}
              sx={{ width: 150 }}
              disabled={disableProductName}
            />
          </Grid>
          <Grid item xs="auto">
            産地:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeProductDataInput("origin")}
              onBlur={handleBlurProductDataInput("origin")}
              value={productDataInputValue.origin}
              sx={{ width: 100}}
              inputProps={{border: 0}}
              readOnly
            />
          </Grid>
          <Grid item xs="auto">
            規格:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeProductDataInput("displaySize")}
              onBlur={handleBlurProductDataInput("displaySize")}
              value={productDataInputValue.displaySize}
              sx={{ width: 100 }}
              readOnly
            />
          </Grid>
          <Grid item xs="auto">
            発注単位:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onBlur={handleBlurProductDataInput("orderingUnit")}
              onChange={handleChangeProductDataInput("orderingUnit")}
              value={productDataInputValue.orderingUnit}
              sx={{ width: 100 }}
              readOnly
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
